import { useState } from "react";

import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { AcceptInvitationForm, AcceptInvitationFormValues } from "@/components/[routes]/accept/accept-invitation-form";
import { apiClient } from "@/core/api/api-client";

export const Route = createFileRoute("/accept/$token")({
  component: AcceptInvitation,
});

function AcceptInvitation() {
  const { token } = Route.useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (data: AcceptInvitationFormValues): Promise<boolean> => {
    setLoading(true);
    setError("");

    try {
      await apiClient.post("/api/accept", {
        token,
        plainPassword: data.password,
      });

      await new Promise((resolve) => setTimeout(resolve, 500));
      navigate({ to: "/login" });
      return true;
    } catch (err) {
      let message = t("accept_invitation.error.unexpected");

      if (typeof err === "object" && err !== null && "response" in err) {
        const response = (err as { response?: { status?: number } }).response;
        if (response?.status === 400) {
          message = t("accept_invitation.error.invalid_token");
        } else if (response?.status === 404) {
          message = t("accept_invitation.error.token_not_found");
        } else if (response?.status === 410) {
          message = t("accept_invitation.error.token_expired");
        }
      } else if (err instanceof Error && err.message.includes("Network Error")) {
        message = t("accept_invitation.error.network");
      }

      setError(message);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return <AcceptInvitationForm onSubmit={handleSubmit} loading={loading} error={error} />;
}
